// Angular modules
import { Pipe }          from '@angular/core';
import { PipeTransform } from '@angular/core';

@Pipe({
  name : 'enumToArray'
})
export class EnumToArrayPipe implements PipeTransform
{
  transform(data : Object) : string[]
  {
    return Object.keys(data);
  }
}